module.exports = __webpack_public_path__ + "static/media/outer_edge_r.7fb625d1.svg";